export enum CompareUscSpecSection {
    Dimensions = "dimensions",
    Consumption = "consumption",
    Engine = "engine",
    Performance = "performance",
    Transmission = "transmission",
}
